module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lijstofdetail),
      expression: "lijstofdetail"
    }],
    staticStyle: {
      "position": "fixed"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "margin": "0px",
      "margin-left": "0px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nieuweMachineClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v("Machine")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "margin": "0px",
      "margin-left": "10px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nieuweSoortClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v("Soort")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "black white--text",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectClick($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.selicon))]), _vm._v("selectie")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "purple white--text",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.selmode == 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.steekkaartenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")]), _vm._v("Steekkaarten")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "orange white--text",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.steekkaartenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("home")]), _vm._v("Locatie")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "blue white--text",
    staticStyle: {
      "margin": "0px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.afdrukkenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lijstofdetail),
      expression: "lijstofdetail"
    }],
    staticClass: "topclass"
  }, [_c('table', [_c('thead', {
    staticStyle: {
      "position": "fixed",
      "margin-top": "46px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', {
    staticStyle: {
      "max-height": "70px",
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('th', {
    staticClass: "idcol headercell"
  }, [_c('v-text-field', {
    staticClass: "textfieldcell",
    attrs: {
      "label": "",
      "prepend-icon": "filter_list"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.IDfilter),
      callback: function($$v) {
        _vm.IDfilter = $$v
      },
      expression: "IDfilter"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "omschrcol headercell"
  }, [_c('v-text-field', {
    staticClass: "textfieldcell",
    attrs: {
      "label": "",
      "prepend-icon": "search"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.materieelfilter),
      callback: function($$v) {
        _vm.materieelfilter = $$v
      },
      expression: "materieelfilter"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "loccol headercell",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "padding-top": "0px",
      "margin-top": "0px"
    },
    attrs: {
      "items": _vm.locdata,
      "item-text": "text",
      "item-value": "werfnr",
      "return-object": "",
      "single-line": "",
      "no-data-text": "Geen Gegevens"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.LOCfilterModel),
      callback: function($$v) {
        _vm.LOCfilterModel = $$v
      },
      expression: "LOCfilterModel"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "urofkmcol headercell"
  }, [_c('button', {
    class: {
      omringd: _vm.UrofkmFilter == -1
    },
    staticStyle: {
      "background-color": "white",
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.seturofkmfilter(-1)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      omringd: _vm.UrofkmFilter == 1
    },
    staticStyle: {
      "background-color": "orange",
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.seturofkmfilter(1)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      omringd: _vm.UrofkmFilter == 0
    },
    staticStyle: {
      "background-color": "red",
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.seturofkmfilter(0)
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "periodiekecol headercell"
  }, [_c('button', {
    class: {
      omringd: _vm.PeriodiekeFilter == -1
    },
    staticStyle: {
      "background-color": "white",
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriodiekeFilter(-1)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      omringd: _vm.PeriodiekeFilter == 1
    },
    staticStyle: {
      "background-color": "orange",
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriodiekeFilter(1)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      omringd: _vm.PeriodiekeFilter == 0
    },
    staticStyle: {
      "background-color": "red",
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriodiekeFilter(0)
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "vorstvrijcol headercell"
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px",
      "margin-left": "20px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.updateFilters
    },
    model: {
      value: (_vm.vorstvrijfilter),
      callback: function($$v) {
        _vm.vorstvrijfilter = $$v
      },
      expression: "vorstvrijfilter"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "defectcol headercell"
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px",
      "margin-left": "20px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.updateFilters
    },
    model: {
      value: (_vm.defectfilter),
      callback: function($$v) {
        _vm.defectfilter = $$v
      },
      expression: "defectfilter"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "hlcol headercell"
  }), _vm._v(" "), _c('th', {
    staticClass: "vikcol headercell"
  }), _vm._v(" "), _c('th', {
    staticClass: "riecol headercell"
  }), _vm._v(" "), _c('th', {
    staticClass: "cecol headercell"
  }), _vm._v(" "), _c('th', {
    staticClass: "idvcol headercell"
  })])]), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.matdata), function(entry) {
    return _c('div', {
      staticClass: "matgroep"
    }, [_c('tr', {
      class: {
        'emptysoort-row': entry.dat.length === 0
      },
      on: {
        "click": function($event) {
          return _vm.clickedSoort(entry)
        }
      }
    }, [_c('td', {
      class: ['soortrow', {
        'emptysoort': entry.dat.length === 0
      }],
      attrs: {
        "colspan": "12"
      }
    }, [_c('div', [_vm._v(_vm._s(entry.soortID) + " - " + _vm._s(entry.soort))])])]), _vm._v(" "), _vm._l((entry.dat), function(e) {
      return _c('tr', {
        class: {
          selectedRow: e.selected
        },
        on: {
          "click": function($event) {
            return _vm.clicked(e)
          }
        }
      }, [_c('td', {
        staticClass: "idcol"
      }, [_c('div', [_vm._v(_vm._s(e.soortID) + "." + _vm._s(e.volgnr))])]), _vm._v(" "), _c('td', {
        staticClass: "omschrcol",
        staticStyle: {
          "text-overflow": "ellipsis"
        }
      }, [_c('div', [_vm._v(_vm._s(e.omschrtekst))])]), _vm._v(" "), _c('td', {
        staticClass: "loccol"
      }, [_c('div', [_vm._v(_vm._s(e.locatieHuidig))])]), _vm._v(" "), _c('td', {
        class: {
          urofkmcol: true, oranjeachtergrond: e.oranjeachtergrond, rodeachtergrond: e.rodeachtergrond
        }
      }, [_c('div', [_vm._v(_vm._s(e.urenofkmoh))])]), _vm._v(" "), _c('td', {
        class: {
          periodiekecol: true, oranjeachtergrond: e.oranjeachtergrondperiodiek, rodeachtergrond: e.rodeachtergrondperiodiek
        }
      }, [_c('div', [_vm._v(_vm._s(e.periodiekecontrole))])]), _vm._v(" "), _c('td', {
        staticClass: "vorstvrijcol",
        staticStyle: {
          "padding-left": "32px"
        }
      }, [(e.vorstvrij) ? _c('div', [_vm._v("✓")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "defectcol",
        staticStyle: {
          "padding-left": "32px"
        }
      }, [(e.defect) ? _c('div', [_vm._v("✓")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "hlcol",
        staticStyle: {
          "padding-left": "0px"
        }
      }, [(e.HL) ? _c('div', [_vm._v("✓")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "vikcol",
        staticStyle: {
          "padding-left": "0px"
        }
      }, [(e.VIK) ? _c('div', [_vm._v("✓")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "riecol",
        staticStyle: {
          "padding-left": "0px"
        }
      }, [(e.RIE) ? _c('div', [_vm._v("✓")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "cecol",
        staticStyle: {
          "padding-left": "0px"
        }
      }, [(e.CE) ? _c('div', [_vm._v("✓")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "idvcol",
        staticStyle: {
          "padding-left": "0px"
        }
      }, [(e.IDV) ? _c('div', [_vm._v("✓")]) : _vm._e()])])
    })], 2)
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lijstofdetail),
      expression: "!lijstofdetail"
    }]
  }, [_c('materieeldetail', {
    attrs: {
      "werven": _vm.werven,
      "soortendata": _vm.soortendata
    },
    on: {
      "backMaterieel": _vm.backMaterieel
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.showNewMachineDialog),
      callback: function($$v) {
        _vm.showNewMachineDialog = $$v
      },
      expression: "showNewMachineDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Machine Toevoegen")])]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.soortendata,
      "item-text": "text",
      "item-value": "soortID",
      "return-object": "",
      "label": "soort",
      "single-line": "",
      "required": "",
      "no-data-text": "Geen Gegevens"
    },
    model: {
      value: (_vm.nieuweMachineSoort),
      callback: function($$v) {
        _vm.nieuweMachineSoort = $$v
      },
      expression: "nieuweMachineSoort"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "volgnr",
      "required": ""
    },
    model: {
      value: (_vm.nieuweMachineVolgnr),
      callback: function($$v) {
        _vm.nieuweMachineVolgnr = $$v
      },
      expression: "nieuweMachineVolgnr"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "merk",
      "required": ""
    },
    model: {
      value: (_vm.nieuweMachineMerk),
      callback: function($$v) {
        _vm.nieuweMachineMerk = $$v
      },
      expression: "nieuweMachineMerk"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "type",
      "required": ""
    },
    model: {
      value: (_vm.nieuweMachineOmschr),
      callback: function($$v) {
        _vm.nieuweMachineOmschr = $$v
      },
      expression: "nieuweMachineOmschr"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "bouw-/aankoopjaar",
      "required": ""
    },
    model: {
      value: (_vm.nieuweMachineJaar),
      callback: function($$v) {
        _vm.nieuweMachineJaar = $$v
      },
      expression: "nieuweMachineJaar"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "serienr",
      "required": ""
    },
    model: {
      value: (_vm.nieuweMachineSerienr),
      callback: function($$v) {
        _vm.nieuweMachineSerienr = $$v
      },
      expression: "nieuweMachineSerienr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.TError))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "blue--text darken-1",
    nativeOn: {
      "click": function($event) {
        _vm.showNewMachineDialog = false
      }
    }
  }, [_vm._v("Sluiten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    nativeOn: {
      "click": function($event) {
        return _vm.nieuweMachineSaveClick($event)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.showNewSoortDialog),
      callback: function($$v) {
        _vm.showNewSoortDialog = $$v
      },
      expression: "showNewSoortDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [(_vm.nieuweSoortWijzigen) ? _c('span', {
    staticClass: "headline"
  }, [_vm._v("Soort Wijzigen")]) : _vm._e(), _vm._v(" "), (!_vm.nieuweSoortWijzigen) ? _c('span', {
    staticClass: "headline"
  }, [_vm._v("Soort Toevoegen")]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "NR",
      "hint": "bijvoorbeeld: 01",
      "disabled": _vm.nieuweSoortWijzigen,
      "required": ""
    },
    on: {
      "input": _vm.nieuweSoortDataGewijzigd
    },
    model: {
      value: (_vm.nieuweSoortID),
      callback: function($$v) {
        _vm.nieuweSoortID = $$v
      },
      expression: "nieuweSoortID"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "NAAM",
      "hint": "bijvoorbeeld: Traktor",
      "required": ""
    },
    on: {
      "input": _vm.nieuweSoortDataGewijzigd
    },
    model: {
      value: (_vm.nieuweSoortNaam),
      callback: function($$v) {
        _vm.nieuweSoortNaam = $$v
      },
      expression: "nieuweSoortNaam"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "SUBMAP",
      "hint": "mapnaam op de cloud",
      "required": ""
    },
    model: {
      value: (_vm.nieuweSoortMap),
      callback: function($$v) {
        _vm.nieuweSoortMap = $$v
      },
      expression: "nieuweSoortMap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.TError))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "blue--text darken-1",
    nativeOn: {
      "click": function($event) {
        _vm.showNewSoortDialog = false
      }
    }
  }, [_vm._v("Sluiten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.nieuweSoortWijzigen) ? _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "disabled": _vm.soortHeeftMachines
    },
    nativeOn: {
      "click": function($event) {
        return _vm.soortVerwijderenClicked($event)
      }
    }
  }, [_vm._v("\n          Verwijderen\n        ")]) : _vm._e(), _vm._v(" "), (_vm.nieuweSoortWijzigen) ? _c('v-spacer') : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    nativeOn: {
      "click": function($event) {
        return _vm.nieuweSoortSaveClick($event)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "60px",
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('th', {
    staticClass: "idcol"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "omschrcol"
  }, [_vm._v("OMSCHRIJVING")]), _vm._v(" "), _c('th', {
    staticClass: "loccol"
  }, [_vm._v("HUIDIGE LOCATIE")]), _vm._v(" "), _c('th', {
    staticClass: "urofkmcol"
  }, [_vm._v("UREN/"), _c('br'), _vm._v("KM/"), _c('br'), _vm._v("ONDERH.")]), _vm._v(" "), _c('th', {
    staticClass: "periodiekecol"
  }, [_vm._v("PERIODIEKE CONTROLE GELDIG TOT")]), _vm._v(" "), _c('th', {
    staticClass: "vorstvrijcol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("VORSTVRIJ")]), _vm._v(" "), _c('th', {
    staticClass: "defectcol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("DEFECT")]), _vm._v(" "), _c('th', {
    staticClass: "hlcol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("HL")]), _vm._v(" "), _c('th', {
    staticClass: "vikcol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("VIK")]), _vm._v(" "), _c('th', {
    staticClass: "riecol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("RIE")]), _vm._v(" "), _c('th', {
    staticClass: "cecol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('th', {
    staticClass: "idvcol",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("IDV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "height": "196px"
    },
    attrs: {
      "colspan": "12"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b578cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/materieel.vue
// module id = 46
// module chunks = 3